<template>
  <v-menu
    offset-y
    v-model="showYearContent"
    z-index="10"
    :disabled="disabled"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on, attrs }">
      <!-- <div v-bind="attrs"
           v-on="on"
           style="height:40px;font-size:16px;">{{year}}</div> -->
      <mrc_ess_input v-bind="attrs" v-on="on" v-model="year"></mrc_ess_input>
    </template>
    <div style="background-color: #fff; max-width: 328px; position: relative">
      <div
        class="d-flex justify-space-around align-center pt-5"
        style="height: 40px; font-size: 18px"
      >
        <v-btn icon @click="toLeft()">
          <v-icon class="material-icons">navigate_before</v-icon>
        </v-btn>
        <strong>{{ yearStart }}--{{ yearEnd - 1 }}</strong>
        <v-btn icon @click="toRight()">
          <v-icon class="material-icons">navigate_next</v-icon>
        </v-btn>
      </div>
      <div class="d-flex justify-space-evenly flex-wrap pb-10">
        <span
          v-for="(item, index) in yearList"
          :key="index"
          :style="{
            display: 'block',
            width: '108px',
            'text-align': 'center',
            height: '40px',
            'line-height': '40px',
            'background-color': item.active ? 'rgba(157, 219, 252, 0.41)' : '',
          }"
          :class="{ 'year-text': 1, 'year-disable': yearDis(item.time) }"
          @click="chooseYear(item, index)"
          >{{ item.time }}
        </span>
      </div>
      <div style="position: absolute; bottom: 0; right: 0">
        <v-btn
          class="mr-4"
          color="#fff"
          depressed
          @click="showYearContent = false"
          >clear</v-btn
        >
        <v-btn color="#fff" depressed @click="success">ok</v-btn>
      </div>
    </div>
  </v-menu>
</template>

<script>
export default {
  name: "YearPicker",
  props: {
    yearDisable: {
      type: String,
      default: "no",
    },
    yearTime: {
      type: [String, Number],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
  },
  model: {
    prop: "yearTime",
    event: "changeYear",
  },
  data() {
    return {
      yearList: [],
      year: "",
      showYearContent: false,
      yearStart: null,
      yearEnd: null,
      currentYear: null,
    };
  },
  mounted() {
    var myDate = new Date();
    var tYear = myDate.getFullYear();
    this.currentYear = tYear;
    this.yearStart = tYear;
    this.yearEnd = tYear + 12;
    for (let i = this.yearStart; i < this.yearEnd; i++) {
      this.yearList.push({
        time: i,
        active: false,
      });
    }
  },
  methods: {
    chooseYear(item, index) {
      if (
        this.yearDisable == "before" &&
        !Boolean(item.time > this.currentYear)
      )
        return;
      if (
        this.yearDisable == "after" &&
        !Boolean(item.time <= this.currentYear)
      )
        return;
      this.year = item.time;
      this.yearList.map((item1) => {
        item1.active = false;
      });
      this.$set(this.yearList, index, { ...item, active: !item.active });
    },
    toLeft() {
      this.yearStart -= 12;
      this.yearEnd -= 12;
      let arr = [];
      for (let i = this.yearStart; i < this.yearEnd; i++) {
        arr.push({
          time: i,
          active: false,
        });
      }
      this.yearList = arr;
    },
    toRight() {
      this.yearStart += 12;
      this.yearEnd += 12;
      let arr = [];
      for (let i = this.yearStart; i < this.yearEnd; i++) {
        arr.push({
          time: i,
          active: false,
        });
      }
      this.yearList = arr;
    },
    success() {
      this.$emit("changeYear", this.year);
      this.showYearContent = false;
    },
  },
  computed: {
    yearDis() {
      return function (y) {
        switch (this.yearDisable) {
          case "before":
            {
              return y < new Date().getFullYear();
            }
            break;
          case "no":
            {
              return false;
            }
            break;
          case "after": {
            return y > new Date().getFullYear();
          }
        }
      };
    },
  },
};
</script>

<style scoped lang='scss'>
.year-text {
  color: #525252;
  font-size: 16px;
  width: 48px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.year-text:hover {
  cursor: pointer;
  background: rgba(157, 219, 252, 0.41);
  border-radius: 3px;
}

.year-disable {
  background: #f5f5f5;
}

.year-disable:hover {
  cursor: no-drop;
  background: #f5f5f5;
}
</style>
